<template>
    <div>
        <div style=" padding: 25px;" id="carrusel_onboarding">
            <div class="text-dark text-bold">
                <div v-if="!showForm">
                    <h2 class="text-bold" style="font-weight: 900; margin-bottom: 15px;">
                        {{
                            esExtranjero()
                            ? 'Digital onboarding'
                            : 'Aprobación de buró de crédito'
                        }}
                    </h2>
                    <p style="font-size: 16px;">
                        {{
                            esExtranjero()
                            ? 'Before starting the process, read these simple instructions.'
                            : 'Antes de comenzar el proceso, lee estas sencillas instrucciones.'
                        }}
                    </p>
                    <div class="d-flex justify-content-center text-start">
                        <ul style="display: flex; flex-direction: column; color" class="list__pre-onboarding">
                            <li v-for="{ title, text, id } in instrucctions" :key="id">
                                <h6>{{ title }}</h6>
                                <p>{{ text }}</p>
                            </li>

                        </ul>
                    </div>
                    <p style="font-size: 14px;">
                        {{
                            esExtranjero() ?
                            'For future procedures we will save the data of this authentication (passport and signature), so you will avoid repeating the process. ' : 'Guardaremos tu información para futuros trámites, evitando que tengas que repetir el proceso.'
                        }}
                    </p>
                    <div class="d-flex flex-column gap-2 justify-content-center align-items-center">
                        <v-btn elevation="2" color="primary" style="max-width: 400px; width: 100%;"
                            @click="showForm = true">
                            {{ esExtranjero() ? 'Accept' : 'Aceptar' }}
                        </v-btn>
                        <v-btn elevation="2" color="primary" outlined style="max-width: 400px; width: 100%;"
                            @click="cleanPreonboarding">
                            {{ esExtranjero() ? 'Cancel' : 'Cancelar' }}
                        </v-btn>
                    </div>
                </div>


                <div class="d-flex justify-content-center flex-column align-items-center mt-5 gap-3 " v-if="showForm">
                    <h2> {{ esExtranjero() ? 'You´re about to get started' : 'Estás a punto de empezar' }}</h2>
                    <p> {{ esExtranjero() ? 'Kindly specify the identification document you intend to use.' : 'Indícanos el documento de identificación que deseas utilizar.'}}</p>
                    <form style="width: 100%;">
                        <label class="my-2"> {{ esExtranjero() ? 'Identification Type' : 'Tipo de identificación' }}</label>
                        <v-select v-model="identity" :items="esExtranjero() ? englishItems : items" item-text="option"
:label="esExtranjero() ? 'Select' : 'Selecciona'" style="max-width: 400px;" filled clearable />
                    </form>
                    <v-btn elevation="2" :disabled="!identity" color="primary" x-large
                        style="margin: 0 0 25px 0; width: 100%;" @click="goTo">
                        {{
                            esExtranjero() ?
                            'Start'
                            : 'Iniciar'
                        }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template> 
<script>
import servicios from "../../../servicios/service.js";
export default {
    name: 'Carousel',
    data: () => ({
        identity: null,
        items: [
            { option: 'INE/IFE', abbr: 'front' },
            { option: 'Pasaporte', abbr: 'passport' },

        ],
        englishItems: [
            { option: 'INE/IFE', abbr: 'front' },
            { option: 'Passport', abbr: 'passport' },
        ],
        instrucctionsSpanish: [
            {
                id: 1,
                title: 'Permite tu ubicación',
                text: 'Al aceptar nos permites brindarte mayor seguridad en tus operaciones.'
            },
            {
                id: 2,
                title: 'Permite uso de tu camará',
                text: 'Al aceptar nos permites autenticar tu identidad mediante una fotográfia.'
            },
            {
                id: 3,
                title: 'Identificación oficial',
                text: 'Ten tu INE o Pasaporte a mano, verifica que estén vigentes y asegúrate de tomar la foto con una iluminación adecuada (sin destellos).'
            },
            {
                id: 4,
                title: 'Reconocimiento facial',
                text: 'Asegúrate de tener buena iluminación, tu rostro debe de estar descubierto y sin lentes ni accesorios.'
            },
            {
                id: 5,
                title: 'Conexión WiFi estable',
                text: 'Tu conexión a internet es importante para realizar tu autenticación.'
            },

        ],
        instrucctionsEnglish: [
            {
                id: 1,
                title: 'Allow your location ',
                text: 'By accepting you allow us to provide you with greater security in your operations.'
            },
            {
                id: 2,
                title: 'Allow use of your camera',
                text: 'By accepting you allow us to authenticate your identity through a photograph.'
            },
            {
                id: 3,
                title: 'Official ID ',
                text: 'Have your INE or passport on hand, verify that they´re valid and make sure to take the photo with adequate lighting (no glare light).'
            },
            {
                id: 4,
                title: 'Facial recognition ',
                text: 'Make sure you have good lighting, your face must be uncovered and without glasses or accessories.'
            },
            {
                id: 5,
                title: 'Stable Wi-Fi connection ',
                text: 'Your internet connection is important to authenticate you. '
            },
        ],
        showForm: false
    }),
    mounted() {
        //Change
        sessionStorage.removeItem("preonboarding");
    },
    methods: {
        goTo() {
            this.$store.commit('setSelectionDocument', this.identity);
            this.$router.push({ name: 'IntegracionExpedienteIncodeV2' });
        },
        cleanPreonboarding() {
            sessionStorage.removeItem('preonboarding')
            //iDENTIFICAR EL TIPO DE PERSONA PARA REGRESARLO A SU PANTALLA ADECUADA 
            if (this.$store.getters.tipoPersona === 0) {
                //Fisica
                this.$router.push({ name: 'IntegracionExpediente' });
            }
            else if (this.$store.getters.tipoPersona === 1) {
                //Moral
                this.$router.push({ name: 'IntegracionExpedienteMoral' });
            }
            else if (this.$store.getters.tipoPersona === 2) {
                //Extranjero
                this.$router.push({ name: 'IntegracionExpedienteExtranjero' });
            }
            else{
                this.$router.push({ name: this.$store.state.goToSinOnboarding.to});
            }
        },
        esExtranjero() {
            return servicios.esExtranjero(this.$store.getters.tipoPersona);
        }
    },
    computed: {
        instrucctions() {
            return this.esExtranjero() ? this.instrucctionsEnglish : this.instrucctionsSpanish
        }
    }
}
</script>
 
<style scoped lang="scss">
.v-window {
    height: 350px !important;
}

.list__pre-onboarding {
    list-style-type: none !important;

    *h6 {
        color: #AE755E !important;
        font-size: 18px !important;
        font-weight: bold;
    }

    *p {
        font-size: 14px !important;
    }

    li {
        position: relative;
    }

    li::before {
        content: "\2022";
        color: #AE755E;
        font-size: 48px;
        position: absolute;
        left: -25px;
        top: -25px;



    }
}
</style>